import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/takeover.vue
var s = {
	name: "DtIconTakeover",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--takeover"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Takeover",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M9.072 1.25a6.866 6.866 0 0 0-1.136 1.761l1.18.107a.043.043 0 0 0 .041-.02l.644-1.073a.043.043 0 0 0-.007-.052l-.722-.722ZM7.584 3.984l1.442.13c.399.037.783-.158.989-.501l.643-1.072c.246-.41.182-.936-.157-1.274L9.778.543C9.4.165 8.751.115 8.348.56a7.972 7.972 0 0 0-2.024 5.337c-.001 2.746 1.33 4.761 1.996 5.6.39.491 1.082.47 1.484.068l.698-.698c.339-.339.403-.864.157-1.275l-.664-1.104a1.043 1.043 0 0 0-.894-.506H7.618a7.577 7.577 0 0 1-.294-2.084c0-.71.102-1.35.26-1.915Zm.392 5a8.53 8.53 0 0 0 1.117 1.879.059.059 0 0 0 .004-.004l.698-.698a.043.043 0 0 0 .007-.053l-.664-1.104a.043.043 0 0 0-.037-.02H7.976ZM3.162 3.898a.5.5 0 0 1 .707 0l1.809 1.809a.5.5 0 0 1 0 .707L3.869 8.222a.5.5 0 0 1-.707-.707l.955-.955h-2.41a.5.5 0 1 1 0-1h2.41l-.955-.954a.5.5 0 0 1 0-.708Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=takeover.js.map